var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2315 4.65439L6.92725 8.60089C6.87061 8.65051 6.82523 8.71166 6.79413 8.78025C6.76304 8.84883 6.74696 8.92327 6.74696 8.99857C6.74696 9.07388 6.76304 9.14831 6.79413 9.2169C6.82523 9.28548 6.87061 9.34663 6.92725 9.39626C6.934 9.40189 6.943 9.40413 6.94975 9.40976L11.2315 13.3473C11.3522 13.4533 11.5074 13.5117 11.668 13.5117C11.8286 13.5117 11.9838 13.4533 12.1045 13.3473C12.1056 13.345 12.1068 13.3416 12.109 13.3394C12.1672 13.2898 12.2141 13.2282 12.2465 13.159C12.2789 13.0897 12.2961 13.0142 12.2969 12.9378L12.2969 5.06276C12.2969 4.90189 12.2204 4.75901 12.1023 4.65664L12.1045 4.65439C11.8626 4.43389 11.4722 4.43389 11.2315 4.65439Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.4698e4532578820e9208ee9b180ff640.svg";
export { ForwardRef as ReactComponent };